import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { withRouter} from 'react-router-dom'
import { tableData,tableData1} from './table2'
import './select.scss'
import {message} from "antd";
import {
    setLbname,
    setLibrary,
    setScoreInfo,
    setMenu, refreshMenu,setLibraryArr
} from "../../redux/common/action";
import {Button, Modal} from "antd";
import {selectLibraryHeader} from "../../servers/goodsManageApi";
@CBaseComponent
class Select extends Component{
    constructor(props) {
        super(props);
        this.onTableChange = this.onTableChange.bind(this);
        this.handleCanceldialog = this.handleCanceldialog.bind(this)
        this.gotoBase = this.gotoBase.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        // reload时重新加载数据
        // this.getDeleteUserListData();
        // this.getUserBussinesRoleListData();
    }


    state = {
        columns: tableData.tHead,
        dataSourceAll:[],
        dataSource: tableData.tBody,
        page: tableData.tPage,

        columns1: tableData1.tHead,
        dataSource1: tableData1.tBody,
        dataSource1all: tableData1.tBody,
        page1: tableData1.tPage,

        loading: true,
        isModalVisible:false,
        voterlist:[]
    };

    onTableChange(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSourceAll))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    onTableChange1(data){
        let d = JSON.parse(JSON.stringify(this.state.dataSource1all))
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page1, ...data.data},
            dataSource1:newDataList
        })
    }

    getAlert(result){
        if (result.voterlist === ''){
            message.error('暂无投票人')
            return
        } else {
            this.setState({
                voterlist:result.voterlist
            },()=>{
                this.setState({
                    isModalVisible:true
                })
            })
        }

    }

    gotoBase(data){
        const params = {
            provinceid:data.provinceid,
            mimid:data.mimid
        }
        selectLibraryHeader(params).then(res=>{
            if (res.records.length > 0) {
                const result = res.records[0].datalist
                result.forEach(item=>{
                    item.name = item.museumname
                })
                this.props.setLibraryArr(result)
                this.props.setLibrary(data.mimid)
                this.props.setLbname(data.museumname)
                localStorage.setItem('chooseid','21')
                this.props.history.push({
                    pathname: '/base'
                })
            }
        })
    }

    handleCanceldialog(){
        this.setState({
            isModalVisible:false,
            page1:tableData1.tPage
        })
    }

    componentWillMount(){

    }

    componentWillReceiveProps(nextProps) {
        let d = JSON.parse(JSON.stringify(nextProps.data))
        let  data = d.splice((nextProps.pagedata.page-1)*nextProps.pagedata.pageSize,nextProps.pagedata.page*nextProps.pagedata.pageSize)
        this.setState({
            dataSourceAll:nextProps.data,
            dataSource:data,
            loading:false,
            page:nextProps.pagedata
        })
    }

    componentDidMount(){
    }
    render(){
        return (
            <div className='history-record-delete-user-list' style={{width:'100%'}}>
                <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns}
                        dataSource={this.state.dataSource} page={this.state.page} onTableChange={this.onTableChange}>
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {(Number(this.state.page.page)-1)*10 + (index + 1)}
                            </div>
                        )}/>
                    <div
                        slot='operatehz'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='text' size="mini" onClick={() => this.getAlert(record)}>
                                    查看
                                </CButton>
                            </div>
                        )}/>
                    <div
                        slot='museumname'
                        render={(text, record, index) => (
                            <div style={{cursor:'pointer',color:'#3e59c2'}} onClick={() => this.gotoBase(record)}>
                                {record.museumname}
                            </div>
                        )}/>
                </CTable>
                <Modal title='投票人列表'
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       width={'400px'}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    {this.state.voterlist}
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        scoreinfo: state.scoreinfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setScoreInfo:bindActionCreators(setScoreInfo,dispatch),
        setLibrary: bindActionCreators(setLibrary, dispatch),
        setLbname: bindActionCreators(setLbname, dispatch),
        setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        refreshMenu: bindActionCreators(refreshMenu, dispatch),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Select);
